import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  TextField,
  Typography,
  Tooltip,
  Button
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { useSelector } from "react-redux";
import config from "../../config/config";

const EmbedPage = () => {
  const theme = useTheme();
  const [valueDirect, setValueDirect] = useState("");
  const [valueLink, setValueLink] = useState("");
  const [valueBtnCode, setValueBtnCode] = useState("");
  const [openDirectLinkTooltip, setOpenDirectLinkTooltip] = useState(false);
  const [openLinkCopyTooltip, setOpenLinkCopyTooltip] = useState(false);
  const [openBtnCodeTooltip, setOpenBtnCodeTooltip] = useState(false);

  const { user } = useSelector(state => ({
    user: state.auth.user,
  }));

  useEffect(() => {
    if (user?.firstName) {
      setValueDirect(`${config.CLIENT_BASE_URL}/${user?.username}/book`);
      setValueLink(`<a href='${config.CLIENT_BASE_URL}/${user?.username}/book'>Launch My Booking Form</a>`);
      const xPos = (window.screen.width - 1400) / 2;
      const yPos = (window.screen.height - 880) / 2;
      setValueBtnCode(`<button onclick="javascript:centeredPopup('${config.CLIENT_BASE_URL}/${user?.username}/book', 'mywindow', 1400,880,1)" style="padding: 10px 20px;">Launch Booking Form</button>\n<script type="text/javascript">\nvar popupWindow = null;\nfunction centeredPopup(url,winName,w,h,scroll)\n{\n\tLeftPosition = (screen.width) ? (screen.width - w)/2 : 0;\n\tTopPosition = (screen.height) ? (screen.height-h)/2 : 0;\n\tsettings = 'height='+h+',width='+w+',top='+TopPosition+',left='+LeftPosition+',location=1, status=1, scrollbars='+scroll+',resizable';\n\tpopupWindow = window.open(url, winName,settings);\n}\n</script>`);
    }
  }, [user]);

  const handleTooltipClose = () => {
    setOpenDirectLinkTooltip(false);
    setOpenLinkCopyTooltip(false);
    setOpenBtnCodeTooltip(false);
  };

  const handleDirectLink = () => {
    copyToClipboard(valueDirect);
    setOpenDirectLinkTooltip(true);
  }

  const handleCopyLink = () => {
    copyToClipboard(valueLink);
    setOpenLinkCopyTooltip(true);
  }

  const handleCopyButtonCode = () => {
    copyToClipboard(valueBtnCode);
    setOpenBtnCodeTooltip(true);
  }

  async function copyToClipboard(textToCopy) {
    // Navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(textToCopy);
    } else {
      // Use the 'out of viewport hidden text area' trick
      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;
          
      // Move textarea out of the viewport so it's not visible
      textArea.style.position = "absolute";
      textArea.style.left = "-999999px";
          
      document.body.prepend(textArea);
      textArea.select();

      try {
        document.execCommand('copy');
      } catch (error) {
        console.error(error);
      } finally {
        textArea.remove();
      }
    };
  }

  return (
    <Container maxWidth="lg">
      <Grid className="page-title" sx={{ my: { sm: 2, md: 5 }, marginInline: 'auto' }}>
        <Typography sx={{ color: '#fff', fontSize: '1.5rem', fontWeight: 600 }}>Embed Booking Form</Typography>
        <Typography sx={{ color: '#fff', fontSize: '0.8rem', fontWeight: 500, mt: '3px', opacity: 0.75 }}>Display your booking form wherever you would like to take bookings: your official website, online profiles, or social media.</Typography>
      </Grid>
	    <Grid container justifyContent='center' sx={{ mt: 3, width: '100%', backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e2d', borderRadius: 2 }}>
        <Container sx={{ width: '94%', py: 5 }}>
          <Grid>
            <Typography sx={{ fontWeight: 700, fontSize: '20px' }}>1. Direct Link</Typography>
            <Typography sx={{ fontSize: '14px', mt: 1, color: theme.palette.mode === 'light' ? '#555' : '#6d6d80', fontWeight: 400 }}>This is the direct link to your booking form. Suitable for placing directly in your online ads, social media profiles or link aggregators.</Typography>
          </Grid>
          <Grid container alignItems="center" sx={{ mt: 1.5 }}>
            <Grid item xs>
              <TextField
                variant="standard"
                fullWidth
                value={valueDirect}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    padding: '8px 20px',
                    borderRadius: '6px',
                    fontSize: '13px',
                    fontWeight: 400,
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md="auto">
              <Tooltip
                open={openDirectLinkTooltip}
                onClose={handleTooltipClose}
                title={'Link Copied!'}
                leaveDelay={500}
                placement='top'
                arrow
                enterTouchDelay={0}
              >
                <Button
                  onClick={handleDirectLink}
                  sx={{
                    textTransform: 'none',
                    fontWeight: 600,
                    minWidth: '7rem',
                    ml: { md: 2 },
                    mt: { xs: 1, md: 0 },
                    backgroundColor: theme.palette.mode === 'light' ? '#f5f8fa' : '#2B2B40',
                    color: theme.palette.mode === 'dark' && '#6D6D80',
                    '&:hover': {
                      color: theme.palette.mode === 'dark' && '#009EF7',
                    }
                  }}
                >
                  Copy Code
                </Button>
              </Tooltip>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid container justifyContent='center' sx={{ mt: 3, width: '100%', backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e2d', borderRadius: 2 }}>
        <Container sx={{ width: '94%', py: 5 }}>
          <Grid>
            <Typography sx={{ fontWeight: 700, fontSize: '20px' }}>2. Embed as a Clickable Link</Typography>
            <Typography sx={{ fontSize: '14px', mt: 1, color: theme.palette.mode === 'light' ? '#555' : '#6d6d80', fontWeight: 400 }}>Provides a simple clickable link. Suitable for most websites that allow for more control.</Typography>
          </Grid>
          <Grid container alignItems="center" sx={{ mt: 1.5 }}>
            <Grid item xs>
              <TextField
                variant="standard"
                fullWidth
                value={valueLink}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    padding: '8px 20px',
                    borderRadius: '6px',
                    fontSize: '13px',
                    fontWeight: 400,
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md="auto">
              <Tooltip
                open={openLinkCopyTooltip}
                onClose={handleTooltipClose}
                title={'Link Copied!'}
                leaveDelay={500}
                placement='top'
                arrow
                enterTouchDelay={0}
              >
                <Button
                  onClick={handleCopyLink}
                  sx={{
                    textTransform: 'none',
                    fontWeight: 600,
                    minWidth: '7rem',
                    ml: { md: 2 },
                    mt: { xs: 1, md: 0 },
                    backgroundColor: theme.palette.mode === 'light' ? '#f5f8fa' : '#2B2B40',
                    color: theme.palette.mode === 'dark' && '#6D6D80',
                    '&:hover': {
                      color: theme.palette.mode === 'dark' && '#009EF7',
                    }
                  }}>
                  Copy Code
                </Button>
              </Tooltip>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid container justifyContent='center' sx={{ mt: 3, width: '100%', backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e2d', borderRadius: 2 }}>
        <Container sx={{ width: '94%', py: 5 }}>
          <Grid>
            <Typography sx={{ fontWeight: 700, fontSize: '20px' }}>3. Embed as a Button</Typography>
            <Typography sx={{ fontSize: '14px', mt: 1, color: theme.palette.mode === 'light' ? '#555' : '#6d6d80', fontWeight: 400 }}>Produces a beautiful button to launch your booking form in a self contained popup window. Suitable for your personal website or sites where you have maximum control over the coding.</Typography>
          </Grid>
          <Grid sx={{ mt: 1.5 }}>
            <TextField
              variant="standard"
              fullWidth
              value={valueBtnCode}
              sx={{ mt: 1 }}
              multiline
              rows={8}
              InputProps={{
                disableUnderline: true,
                style: {
                  padding: '8px 20px',
                  borderRadius: '6px',
                  fontSize: '13px',
                  fontWeight: 400,
                },
              }}
            />
            <Tooltip
              open={openBtnCodeTooltip}
              onClose={handleTooltipClose}
              title={'Code copied!'}
              leaveDelay={500}
              placement='top'
              arrow
              enterTouchDelay={0}
            >
              <Button
                onClick={handleCopyButtonCode}
                sx={{
                  textTransform: 'none',
                  fontWeight: 600,
                  minWidth: '7rem',
                  mt: 2,
                  backgroundColor: theme.palette.mode === 'light' ? '#f5f8fa' : '#2B2B40',
                  color: theme.palette.mode === 'dark' && '#6D6D80',
                  '&:hover': {
                    color: theme.palette.mode === 'dark' && '#009EF7',
                  }
                }}
              >
                Copy Code
              </Button>
            </Tooltip>
          </Grid>
        </Container>
      </Grid>
    </Container>
  );
}

export default EmbedPage;
